<template>
  <div class="serch_border">
    <div class="serchform">
      需求类型：
      <a-tag @click="postSerchData({demand_type:''})"  :class="{'tag-active':demand_types==''}">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==demand_types}" @click="postSerchData({'demand_type':item.dictValue})" v-for="(item,key) in options" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="cont_body">
    <div v-for="(item,key) in dataSource" :key="key" @click="goMore('/finance/need/page','需求详情',item.id)" class="list_cont">
      
      <div class="list_cont_body">
        <h4>{{ item.needName }}</h4>
        <h5>需求方：{{ item.needUserName
        }}</h5>
        <P>需求类型：
          <dict-render :dict-obj="dictObjs['demand_type']"
          :text="item.needType"></dict-render>
        </P>
      </div>
    </div>
  </div>
  <!--分页-->
  <div class="pagination">
    <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
  </div>
</template>
<script>
import { dictMixin, listMixin } from "@/mixins";
import {basicsNeedInfo} from "@/api/finance";
import {common_controller} from "@/api/commonService";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import {financeDict} from "@/config/variableConfig"
export default {
  name: 'investor',
  components: { DictRender },
  mixins: [dictMixin, listMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 查询条件
      demand_types: '',// 投资领域
      financeDict,
      options:null,
      dictNames: 'demand_type',
      listUrl: basicsNeedInfo.pageList,
      queryParamFixed: { 
              needType: this.demand_types,
              systemType: 'finance'
       },
      current: 1,
      pageSize: 12,
    }
  },
  mounted() {
      this.getDict();
  },
	methods: {
    postSerchData(val){
      if(val.demand_type||val.demand_type==''){
        this.queryParamFixed.needType = val.demand_type
        this.demand_types = val.demand_type
      }
      this.loadData()
      
    },
    getDict(){
        this.getAction({
            url:common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: "demand_type"
            }
        }).then(res=>{
            this.options = res
        })
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  width: 389px;
  margin-bottom: 16px;
  margin-right: 16px;
  &:nth-child(3n){
    margin-right: 0;
  }
  .list_img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 10px 20px 25px;
    flex: 1;
    display: flex;
    align-items: center;
    img{
      width:100%
    }
  }
  .list_cont_body{
    padding:20px;
    flex: 5;
  }
}
</style>